// 24px
import { ReactComponent as Mirae24Icon } from '../../assets/logo/securities/미래에셋증권-24.svg'
import { ReactComponent as Samsung24Icon } from '../../assets/logo/securities/삼성증권-24.svg'
import { ReactComponent as KB24Icon } from '../../assets/logo/securities/KB증권-24.svg'
import { ReactComponent as Korea24Icon } from '../../assets/logo/securities/한국투자증권-24.svg'
import { ReactComponent as Kium24Icon } from '../../assets/logo/securities/키움증권-24.svg'
import { ReactComponent as Daishin24Icon } from '../../assets/logo/securities/대신증권-24.svg'
import { ReactComponent as NH24Icon } from '../../assets/logo/securities/NH투자증권-24.svg'
import { ReactComponent as Shinhan24Icon } from '../../assets/logo/securities/신한금융투자-24.svg'
import { ReactComponent as HanaC24Icon } from '../../assets/logo/securities/하나증권-24.svg'
import { ReactComponent as Yuanta24Icon } from '../../assets/logo/securities/유안타증권-24.svg'
import { ReactComponent as HM24Icon } from '../../assets/logo/securities/현대차증권-24.svg'
import { ReactComponent as Hanwha24Icon } from '../../assets/logo/securities/한화투자증권-24.svg'
import { ReactComponent as Kyobo24Icon } from '../../assets/logo/securities/교보증권-24.svg'
import { ReactComponent as Meritz24Icon } from '../../assets/logo/securities/메리츠증권-24.svg'
import { ReactComponent as DB24Icon } from '../../assets/logo/securities/DB금융투자-24.svg'
import { ReactComponent as Hi24Icon } from '../../assets/logo/securities/하이투자증권-24.svg'
import { ReactComponent as Eugene24Icon } from '../../assets/logo/securities/유진투자증권-24.svg'
import { ReactComponent as SK24Icon } from '../../assets/logo/securities/SK증권-24.svg'
import { ReactComponent as SY24Icon } from '../../assets/logo/securities/신영증권-24.svg'
import { ReactComponent as IBK24Icon } from '../../assets/logo/securities/IBK투자증권-24.svg'
import { ReactComponent as Ebest24Icon } from '../../assets/logo/securities/이베스트투자증권-24.svg'
import { ReactComponent as Blank24Icon } from '../../assets/logo/banks/blank-24.svg'

// 30px
import { ReactComponent as Mirae30Icon } from '../../assets/logo/securities/미래에셋증권-30.svg'
import { ReactComponent as Samsung30Icon } from '../../assets/logo/securities/삼성증권-30.svg'
import { ReactComponent as KB30Icon } from '../../assets/logo/securities/KB증권-30.svg'
import { ReactComponent as Korea30Icon } from '../../assets/logo/securities/한국투자증권-30.svg'
import { ReactComponent as Kium30Icon } from '../../assets/logo/securities/키움증권-30.svg'
import { ReactComponent as Daishin30Icon } from '../../assets/logo/securities/대신증권-30.svg'
import { ReactComponent as NH30Icon } from '../../assets/logo/securities/NH투자증권-30.svg'
import { ReactComponent as Shinhan30Icon } from '../../assets/logo/securities/신한금융투자-30.svg'
import { ReactComponent as HanaC30Icon } from '../../assets/logo/securities/하나증권-30.svg'
import { ReactComponent as Yuanta30Icon } from '../../assets/logo/securities/유안타증권-30.svg'
import { ReactComponent as HM30Icon } from '../../assets/logo/securities/현대차증권-30.svg'
import { ReactComponent as Hanwha30Icon } from '../../assets/logo/securities/한화투자증권-30.svg'
import { ReactComponent as Kyobo30Icon } from '../../assets/logo/securities/교보증권-30.svg'
import { ReactComponent as Meritz30Icon } from '../../assets/logo/securities/메리츠증권-30.svg'
import { ReactComponent as DB30Icon } from '../../assets/logo/securities/DB금융투자-30.svg'
import { ReactComponent as Hi30Icon } from '../../assets/logo/securities/하이투자증권-30.svg'
import { ReactComponent as Eugene30Icon } from '../../assets/logo/securities/유진투자증권-30.svg'
import { ReactComponent as SK30Icon } from '../../assets/logo/securities/SK증권-30.svg'
import { ReactComponent as SY30Icon } from '../../assets/logo/securities/신영증권-30.svg'
import { ReactComponent as IBK30Icon } from '../../assets/logo/securities/IBK투자증권-30.svg'
import { ReactComponent as Ebest30Icon } from '../../assets/logo/securities/이베스트투자증권-30.svg'
import { ReactComponent as Blank30Icon } from '../../assets/logo/banks/blank-30.svg'

// 46px
import { ReactComponent as Mirae46Icon } from '../../assets/logo/securities/미래에셋증권-46.svg'
import { ReactComponent as Samsung46Icon } from '../../assets/logo/securities/삼성증권-46.svg'
import { ReactComponent as KB46Icon } from '../../assets/logo/securities/KB증권-46.svg'
import { ReactComponent as Korea46Icon } from '../../assets/logo/securities/한국투자증권-46.svg'
import { ReactComponent as Kium46Icon } from '../../assets/logo/securities/키움증권-46.svg'
import { ReactComponent as Daishin46Icon } from '../../assets/logo/securities/대신증권-46.svg'
import { ReactComponent as NH46Icon } from '../../assets/logo/securities/NH투자증권-46.svg'
import { ReactComponent as Shinhan46Icon } from '../../assets/logo/securities/신한금융투자-46.svg'
import { ReactComponent as HanaC46Icon } from '../../assets/logo/securities/하나증권-46.svg'
import { ReactComponent as Yuanta46Icon } from '../../assets/logo/securities/유안타증권-46.svg'
import { ReactComponent as HM46Icon } from '../../assets/logo/securities/현대차증권-46.svg'
import { ReactComponent as Hanwha46Icon } from '../../assets/logo/securities/한화투자증권-46.svg'
import { ReactComponent as Kyobo46Icon } from '../../assets/logo/securities/교보증권-46.svg'
import { ReactComponent as Meritz46Icon } from '../../assets/logo/securities/메리츠증권-46.svg'
import { ReactComponent as DB46Icon } from '../../assets/logo/securities/DB금융투자-46.svg'
import { ReactComponent as Hi46Icon } from '../../assets/logo/securities/하이투자증권-46.svg'
import { ReactComponent as Eugene46Icon } from '../../assets/logo/securities/유진투자증권-46.svg'
import { ReactComponent as SK46Icon } from '../../assets/logo/securities/SK증권-46.svg'
import { ReactComponent as SY46Icon } from '../../assets/logo/securities/신영증권-46.svg'
import { ReactComponent as IBK46Icon } from '../../assets/logo/securities/IBK투자증권-46.svg'
import { ReactComponent as Ebest46Icon } from '../../assets/logo/securities/이베스트투자증권-46.svg'
import { ReactComponent as Blank46Icon } from '../../assets/logo/banks/blank-46.svg'

type SecurityName =
  | '미래에셋증권'
  | '삼성증권'
  | 'KB증권'
  | '한국투자증권'
  | '키움증권'
  | '대신증권'
  | 'NH투자증권'
  | '신한금융투자'
  | '하나증권'
  | '유안타증권'
  | '현대차증권'
  | '한화투자증권'
  | '교보증권'
  | '메리츠증권'
  | 'DB금융투자'
  | '하이투자증권'
  | '유진투자증권'
  | 'SK증권'
  | '신영증권'
  | 'IBK투자증권'
  | '이베스트투자증권'

interface SecurityIconProps {
  size: 24 | 30 | 46
  name: SecurityName
}

// 24px
const getIcon24 = (name: SecurityName) => {
  switch (name) {
    case '미래에셋증권':
      return <Mirae24Icon />
    case '삼성증권':
      return <Samsung24Icon />
    case 'KB증권':
      return <KB24Icon />
    case '한국투자증권':
      return <Korea24Icon />
    case '키움증권':
      return <Kium24Icon />
    case '대신증권':
      return <Daishin24Icon />
    case 'NH투자증권':
      return <NH24Icon />
    case '신한금융투자':
      return <Shinhan24Icon />
    case '하나증권':
      return <HanaC24Icon />
    case '유안타증권':
      return <Yuanta24Icon />
    case '현대차증권':
      return <HM24Icon />
    case '한화투자증권':
      return <Hanwha24Icon />
    case '교보증권':
      return <Kyobo24Icon />
    case '메리츠증권':
      return <Meritz24Icon />
    case 'DB금융투자':
      return <DB24Icon />
    case '하이투자증권':
      return <Hi24Icon />
    case '유진투자증권':
      return <Eugene24Icon />
    case 'SK증권':
      return <SK24Icon />
    case '신영증권':
      return <SY24Icon />
    case 'IBK투자증권':
      return <IBK24Icon />
    case '이베스트투자증권':
      return <Ebest24Icon />
    default:
      return <Blank24Icon />
  }
}

// 30px
const getIcon30 = (name: SecurityName) => {
  switch (name) {
    case '미래에셋증권':
      return <Mirae30Icon />
    case '삼성증권':
      return <Samsung30Icon />
    case 'KB증권':
      return <KB30Icon />
    case '한국투자증권':
      return <Korea30Icon />
    case '키움증권':
      return <Kium30Icon />
    case '대신증권':
      return <Daishin30Icon />
    case 'NH투자증권':
      return <NH30Icon />
    case '신한금융투자':
      return <Shinhan30Icon />
    case '하나증권':
      return <HanaC30Icon />
    case '유안타증권':
      return <Yuanta30Icon />
    case '현대차증권':
      return <HM30Icon />
    case '한화투자증권':
      return <Hanwha30Icon />
    case '교보증권':
      return <Kyobo30Icon />
    case '메리츠증권':
      return <Meritz30Icon />
    case 'DB금융투자':
      return <DB30Icon />
    case '하이투자증권':
      return <Hi30Icon />
    case '유진투자증권':
      return <Eugene30Icon />
    case 'SK증권':
      return <SK30Icon />
    case '신영증권':
      return <SY30Icon />
    case 'IBK투자증권':
      return <IBK30Icon />
    case '이베스트투자증권':
      return <Ebest30Icon />
    default:
      return <Blank30Icon />
  }
}

// 46px
const getIcon46 = (name: SecurityName) => {
  switch (name) {
    case '미래에셋증권':
      return <Mirae46Icon />
    case '삼성증권':
      return <Samsung46Icon />
    case 'KB증권':
      return <KB46Icon />
    case '한국투자증권':
      return <Korea46Icon />
    case '키움증권':
      return <Kium46Icon />
    case '대신증권':
      return <Daishin46Icon />
    case 'NH투자증권':
      return <NH46Icon />
    case '신한금융투자':
      return <Shinhan46Icon />
    case '하나증권':
      return <HanaC46Icon />
    case '유안타증권':
      return <Yuanta46Icon />
    case '현대차증권':
      return <HM46Icon />
    case '한화투자증권':
      return <Hanwha46Icon />
    case '교보증권':
      return <Kyobo46Icon />
    case '메리츠증권':
      return <Meritz46Icon />
    case 'DB금융투자':
      return <DB46Icon />
    case '하이투자증권':
      return <Hi46Icon />
    case '유진투자증권':
      return <Eugene46Icon />
    case 'SK증권':
      return <SK46Icon />
    case '신영증권':
      return <SY46Icon />
    case 'IBK투자증권':
      return <IBK46Icon />
    case '이베스트투자증권':
      return <Ebest46Icon />
    default:
      return <Blank46Icon />
  }
}

export function SecurityIcon({ size, name }: SecurityIconProps) {
  switch (size) {
    case 24:
      return <>{getIcon24(name)}</>
    case 30:
      return <>{getIcon30(name)}</>
    case 46:
      return <>{getIcon46(name)}</>
  }
}

export type { SecurityName }
